// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".labelling-appear {\r\n  opacity: 0;\r\n}\r\n\r\n.labelling-appear.labelling-appear-active {\r\n  opacity: 1;\r\n  -webkit-transition: opacity 500ms linear;\r\n  transition: opacity 500ms linear;\r\n}\r\n\r\n.labelling-exit {\r\n  opacity: 1;\r\n}\r\n\r\n.labelling-exit.labelling-exit-active {\r\n  opacity: 0;\r\n  -webkit-transition: opacity 500ms linear;\r\n  transition: opacity 500ms linear;\r\n}\r\n\r\n.labelling-exit-done {\r\n  opacity: 0;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
